import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Midnight Editorial Theme - sophisticated, magazine-style aesthetic
export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#D97706", // Warm amber (overridden by API)
          "on-primary": "#FFFFFF",
          "primary-accent": "#4A22B3", // Primary accent
          secondary: "#78716C", // Warm stone (overridden by API)
          "on-secondary": "#FFFFFF",
          "secondary-accent": "#b45309", // Secondary accent
          tertiary: "#059669", // Emerald (overridden by API)
          "on-tertiary": "#FFFFFF",
          "tertiary-accent": "#047857", // Darker emerald
          accent: "#059669", // Emerald
          error: "#DC2626",
          "on-error": "#FFFFFF",
          warning: "#F59E0B",
          "on-warning": "#000000",
          info: "#0EA5E9",
          "on-info": "#FFFFFF",
          success: "#10B981",
          "on-success": "#FFFFFF",
          background: "#FAFAF9", // Warm white
          "on-background": "#1C1917",
          surface: "#FFFFFF",
          "surface-variant": "#F5F5F4",
          "surface-bright": "#FFFFFF",
          "on-surface": "#1C1917",
          "on-surface-variant": "#57534E",
          outline: "#78716C",
          "outline-variant": "#D6D3D1",
          "inverse-surface": "#1C1917",
          "inverse-on-surface": "#FAFAF9",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#F59E0B", // Amber gold (overridden by API)
          "on-primary": "#0C0A09",
          "primary-accent": "#7B3FFF", // Primary accent
          secondary: "#A8A29E", // Warm gray (overridden by API)
          "on-secondary": "#0C0A09",
          "secondary-accent": "#fbbf24", // Secondary accent (amber)
          tertiary: "#34D399", // Emerald light (overridden by API)
          "on-tertiary": "#0C0A09",
          "tertiary-accent": "#10B981", // Emerald accent
          accent: "#34D399", // Emerald light
          error: "#F87171",
          "on-error": "#0C0A09",
          warning: "#FBBF24",
          "on-warning": "#0C0A09",
          info: "#38BDF8",
          "on-info": "#0C0A09",
          success: "#4ADE80",
          "on-success": "#0C0A09",
          background: "#0C0A09", // Near black with warmth
          "on-background": "#FAFAF9",
          surface: "#1C1917", // Charcoal
          "surface-variant": "#292524", // Slightly lighter
          "surface-bright": "#44403C",
          "on-surface": "#FAFAF9",
          "on-surface-variant": "#A8A29E",
          outline: "#78716C",
          "outline-variant": "#44403C",
          "inverse-surface": "#FAFAF9",
          "inverse-on-surface": "#1C1917",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: "flat",
      rounded: "lg",
    },
    VCard: {
      rounded: "xl",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
    },
    VChip: {
      rounded: "lg",
    },
  },
});
